export class CompPackOrderLessonValues {
    constructor(lessonsNr: number, lessonWebNr: number, lessonArcNr: number, lessonDefNr: number, packagePositionNr: number) {
        this.lessonNr = lessonsNr;
        this.lessonsNr = lessonsNr;
        this.lessonWebNr = lessonWebNr;
        this.lessonArcNr = lessonArcNr;
        this.lessonDefNr = lessonDefNr;
        this.packagePositionNr = packagePositionNr;
    }

    /*
     * TODO: get rid of the duality of lessonsNr/lessonNr throughout all TS/C#
     * In the final C# request lessonNr (lesson in singular) is the one that's used.
     */
    lessonNr: number;
    lessonsNr: number;
    lessonWebNr: number;
    lessonArcNr: number;
    lessonDefNr: number;
    packagePositionNr: number;
}